import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import axios from "@/libs/api.request";
import { auth } from "./api_url";
/**
 * 获取自己的角色列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getmygroup = function getmygroup(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmygroup,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 登录成功获取当前用户菜单
 * @param data
 * @returns {*|{responseURL}}
 */

export var login_success_permission = function login_success_permission(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.login_success_permission,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 配置账号的权限
 * @param data
 * @returns {*|{responseURL}}
 */

export var Permission_config = function Permission_config(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.Permission_config,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 账号管理 权限配置页面（获取菜单列表和接口列表）
 * @param data
 * @returns {*|{responseURL}}
 */

export var getmenu_permission = function getmenu_permission(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmenu_permission,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取子账号列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getadminlist = function getadminlist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getadminlist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除子账号
 * @param data
 * @returns {*|{responseURL}}
 */

export var admin_del = function admin_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.admin_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑子账号
 * @param data
 * @returns {*|{responseURL}}
 */

export var admin_update = function admin_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.admin_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 禁用启用子账号
 * @param data
 * @returns {*|{responseURL}}
 */

export var change_adminstatus = function change_adminstatus(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.change_adminstatus,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增子账号
 * @param data
 * @returns {*|{responseURL}}
 */

export var adduser = function adduser(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.adduser,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //获取用户列表

/**
 * 获取所有角色列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getgrouplist = function getgrouplist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getgrouplist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 角色管理 角色权限配置 保存操作
 * @param data
 * @returns {*|{responseURL}}
 */

export var groupPermission_config = function groupPermission_config(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.groupPermission_config,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 角色管理 角色权限配置获取基本数据
 * @param data
 * @returns {*|{responseURL}}
 */

export var getgroup_permission = function getgroup_permission(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getgroup_permission,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑角色
 * @param data
 * @returns {*|{responseURL}}
 */

export var group_update = function group_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.group_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除角色
 * @param data
 * @returns {*|{responseURL}}
 */

export var delgroup = function delgroup(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.delgroup,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取角色列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var grouplist = function grouplist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.grouplist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增角色
 * @param data
 * @returns {*|{responseURL}}
 */

export var addgroup = function addgroup(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addgroup,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 菜单接口配置时执行保存操作
 * @param data
 * @returns {*|{responseURL}}
 */

export var api_config_update = function api_config_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.api_config_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 菜单列表接口配置时获取基本数据
 * @param data
 * @returns {*|{responseURL}}
 */

export var api_config_data = function api_config_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.api_config_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑菜单
 * @param data
 * @returns {*|{responseURL}}
 */

export var menu_update = function menu_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.menu_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除菜单
 * @param data
 * @returns {*|{responseURL}}
 */

export var menu_del = function menu_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.menu_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取菜单列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getmenulist = function getmenulist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmenulist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增菜单或页面
 * @param data
 * @returns {*|{responseURL}}
 */

export var addmenu = function addmenu(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addmenu,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 根据模块名称获取接口列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getmodule_api = function getmodule_api(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmodule_api,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var resource_update = function resource_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resource_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var resourcedel = function resourcedel(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resourcedel,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取接口列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var resourcelist = function resourcelist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.resourcelist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var addresource = function addresource(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addresource,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取模块列表（新增接口时）
 * @param data
 * @returns {*|{responseURL}}
 */

export var getmodule = function getmodule(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.getmodule,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑模块
 * @param data
 * @returns {*|{responseURL}}
 */

export var module_update = function module_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.module_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除模块
 * @param data
 * @returns {*|{responseURL}}
 */

export var moduledel = function moduledel(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.moduledel,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取模块列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var modulelist = function modulelist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.modulelist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增模块
 * @param data
 * @returns {*|{responseURL}}
 */

export var addmodule = function addmodule(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.addmodule,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //设置默认角色

export var default_role = function default_role(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: auth.default_role,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //获取用户列表

export var getUserlist = function getUserlist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_list',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //新增用户

export var addUserlist = function addUserlist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_add',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //禁用启用用户

export var openOroffUser = function openOroffUser(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_status',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //删除用户

export var delUser = function delUser(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_del',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //编辑用户

export var editUser = function editUser(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/user/user_update',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};